module.exports = __webpack_public_path__ + "img/fb-cover.29f0fba5.png";